import { getOnlinePaidUsers } from '../../../api/paidUsers';
import PaidUserCard from '../../customComponents/PaidUserCard/PaidUserCard';
import style from './FreeUserSoulmates.module.css';
import { useEffect, useMemo, useState } from 'react';

const FreeUserSoulmates = ({}) => {
  const [paidUsers, setPaidUsers] = useState([]);
  const [nickname, setNickname] = useState('');

  useEffect(() => {
    getOnlinePaidUsers().then(setPaidUsers);
  }, []);
  const filterUsers = useMemo(() => {
    return paidUsers.filter(user => user.nickname.startsWith(nickname));
  }, [nickname, paidUsers]);

  return (
    <div className={style.onlineSoulMates}>
      <h2> Search online soulmates</h2>
      <input
        value={nickname}
        onChange={event => setNickname(event.target.value)}
        placeholder="Type Nickname"
        className={style.searchInput}
      />

      <div className={style.onlineContainer}>
        {filterUsers.map((item, i) => (
          <PaidUserCard user={item} key={i} />
        ))}
      </div>
    </div>
  );
};

export default FreeUserSoulmates;
